export const PageViewEventsId = {
    HOME: 9748445725091840
};

export const ClickEventsId = {
};
